import {getEnvConfig} from './environment';
import {ITranslateService, TranslateService} from './translateService';

export class TranslateLegacy {
  private static _instance: ITranslateService | null = null;
  private static defaultLanguage: string;

  public static get instance(): ITranslateService {
    if (!TranslateLegacy._instance) {
      if (!TranslateLegacy.defaultLanguage) {
        throw new Error(
          "no default language set. Please initialize using 'Translate.initialize(defaultLanguage);' first!",
        );
      }

      TranslateLegacy._instance = new TranslateService(getEnvConfig());
    }
    return TranslateLegacy._instance;
  }

  public static async initialize(defaultLanguage: string): Promise<void> {
    TranslateLegacy.defaultLanguage = defaultLanguage;
    const inst = TranslateLegacy.instance;
    await inst.initialize(TranslateLegacy.defaultLanguage);
  }
}
